import AssocAsssetsWidget from "./AssocAssetsWidget";
const assetsExports = {
  "views.components.assetInformationActions": [{ component: AssocAsssetsWidget, key: "assets" }]
};
export default assetsExports;
